import React from "react";
import "../../styles/testimonial.css";
import Slider from "react-slick";
import avatar1 from "../../assets/images/avatar1.png";
import { useTranslation } from "react-i18next";

const Testimonial = () => {
  const { t } = useTranslation();

  const settings = {
    dots: false,
    infinite: true,
    speed: 1500,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
  };

  return (
    <section className="testimonial">
      <div className="container">
        <div className="slide-top-content">
          <h6 className="subtitle">{t("TESTIMONIALS_TITLE_1")}</h6>
          <h2>
            <span className="highlight"> {t("TESTIMONIALS_TITLE_2")}</span>
            {t("TESTIMONIALS_TITLE_3")}
          </h2>
        </div>

        <div className="slider-wrapper">
          <Slider {...settings}>
            {Array(5, "").map((item, index) => (
              <div className="slider-item" key={index}>
                <p className="description">{t("TESTIMONIALS_ITEM_DESC")}</p>

                <div className="customer-details">
                  <div className="customer-img">
                    <img src={avatar1} alt="" />
                  </div>

                  <div>
                    <h5 className="customer-name">Jhon Doe</h5>
                    <p className="description">CEO, Workstation</p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
